import React from "react";
import { FormattedMessage, injectIntl, useIntl } from "react-intl";
import moment from "moment";

import { withStyles, Typography, Grid, MenuItem, TextField, Tooltip, IconButton } from "@material-ui/core";
import RefreshIcon from "@material-ui/icons/Refresh";
import SyncIcon from "@material-ui/icons/Sync";

import ErrorMessage from "./ErrorMessage";
import AlarmsTable from "./AlarmsTable";
import styles from "../styles";
import useAlarms from "../services/useAlarms"

const periods = {
  1: {
    count: 1,
    period: "day"
  },
  7: {
    count: 1,
    period: "week"
  },
  14: {
    count: 2,
    period: "weeks"
  },
  30: {
    count: 1,
    period: "month"
  },
  90: {
    count: 3,
    period: "months"
  },
  180: {
    count: 6,
    period: "months"
  },
  365: {
    count: 1,
    period: "year"
  }
};

function AlarmsComponent({ classes }) {
  const intl = useIntl();
  const { 
    alarms, 
    tagsList, 
    period,
    alarmsUpdated, 
    isLoading, 
    message,
    setMessage,  
    isServerRunning, 
    fetchAlarms, 
    triggerServerRun
  } = useAlarms()

  return (
    <React.Fragment>
      <ErrorMessage open={message!==""} onClose={() => setMessage("")} message={message} duration={6000} />
      <Grid container>
        <Grid item xs={6}>
          <Typography variant="h5" color="textSecondary">
            <FormattedMessage id="alarms" />
          </Typography>
        </Grid>
        <Grid item xs={5} className={classes.AlignRight}>
          <div style={{position:"relative", height: "100%"}}>
            <Typography variant="body2" style={{position:"absolute", bottom:4, right:0}}>
              <FormattedMessage id="alarm.last_updated" />
              {(alarmsUpdated) ? moment(alarmsUpdated + "Z").format("YYYY-MM-DD HH:mm:ss") : null}
            </Typography>
          </div>
        </Grid>
        <Grid item xs={1} className={classes.AlignRight}>
          {/* <Tooltip
            placement="top"
            title={intl.formatMessage({id: "alarm.update"})}
          >
            <IconButton
              onClick={() => {fetchAlarms(period)}}
              style={{marginLeft: "-16px"}}
            >
              <RefreshIcon />
            </IconButton> 
          </Tooltip> */}
          <Grid item xs={12}>
            <Tooltip
              placement="top"
              title={intl.formatMessage({id: "alarm.rebuild"})}
            >
              <IconButton
                onClick={triggerServerRun}
                style={{marginLeft: "-16px"}}
                disabled={isServerRunning}
              >
                <SyncIcon />
              </IconButton>
            </Tooltip>
          </Grid>
          <Grid item xs={12}>
            <TextField
              id="standard-select-currency"
              select
              label="Period"
              value={period}
              onChange={(evt) => fetchAlarms(evt.target.value)}
            >
              {Object.keys(periods).map(period => (
                <MenuItem key={period} value={period}>
                  {periods[period]["count"]}
                  &nbsp;
                  <FormattedMessage id={periods[period]["period"]} />
                </MenuItem>
              ))}
            </TextField>        
          </Grid>          
        </Grid>
      </Grid>
      <AlarmsTable
        alarms={alarms}
        loading={isLoading}
        tags={tagsList}
        period={period}
      />  
    </React.Fragment>
  )
}

export default withStyles(styles)(injectIntl(AlarmsComponent));